module.exports = __webpack_public_path__ + "img/escalaApp.8dd740d7.svg";